import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useCurrentWorkspace } from "@/hooks/useCurrentWorkspace";
import { logger } from "@/lib/services/logger";
import { getWorkspaceUserNotificationsQueryOptions, getWorkspaceUserNotificationsSummaryQueryOptions } from "@/queries/notification/fetchers";
import { updateUserNotificationStatus } from "@/queries/notification/updates";
import { notificationMutationKeys } from "@/queries/query-keys/notifications";
export function useNotifications(t0) {
  const $ = _c(25);
  const {
    listEnabled: t1
  } = t0 === undefined ? {} : t0;
  const listEnabled = t1 === undefined ? false : t1;
  const {
    workspaceId
  } = useCurrentWorkspace();
  const queryClient = useQueryClient();
  let t2;
  if ($[0] !== workspaceId) {
    t2 = getWorkspaceUserNotificationsSummaryQueryOptions(workspaceId);
    $[0] = workspaceId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const summaryQueryOptions = t2;
  const listQueryOptions = getWorkspaceUserNotificationsQueryOptions(workspaceId, {
    enabled: listEnabled
  });
  const summaryQuery = useQuery(summaryQueryOptions);
  const listQuery = useQuery(listQueryOptions);
  let t3;
  if ($[2] !== workspaceId) {
    t3 = notificationMutationKeys.update(workspaceId);
    $[2] = workspaceId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== listQueryOptions || $[5] !== queryClient || $[6] !== summaryQueryOptions || $[7] !== t3) {
    let t5;
    if ($[9] !== listQueryOptions || $[10] !== queryClient || $[11] !== summaryQueryOptions) {
      t5 = async () => {
        await Promise.all([queryClient.invalidateQueries({
          queryKey: summaryQueryOptions.queryKey
        }), queryClient.invalidateQueries({
          queryKey: listQueryOptions.queryKey
        })]);
      };
      $[9] = listQueryOptions;
      $[10] = queryClient;
      $[11] = summaryQueryOptions;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = {
      mutationFn: updateUserNotificationStatus,
      mutationKey: t3,
      onError(error, variables) {
        logger.error("Error updating notification", error, {
          variables
        });
        toast.error("Error updating notification");
      },
      onSettled: t5
    };
    $[4] = listQueryOptions;
    $[5] = queryClient;
    $[6] = summaryQueryOptions;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    mutateAsync: updateNotification,
    isPending: updatingNotification,
    variables: variables_0
  } = useMutation(t4);
  let t5;
  if ($[13] !== listQueryOptions || $[14] !== queryClient) {
    t5 = () => queryClient.fetchQuery(listQueryOptions);
    $[13] = listQueryOptions;
    $[14] = queryClient;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = listEnabled ? listQuery.isLoading : summaryQuery.isLoading;
  const t7 = summaryQuery.data?.unreadCount ?? listQuery.data?.unreadCount ?? 0;
  let t8;
  if ($[16] !== listQuery || $[17] !== listQueryOptions || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== updateNotification || $[22] !== updatingNotification || $[23] !== variables_0) {
    t8 = {
      ...listQuery,
      fetchNotificationList: t5,
      getWorkspaceUserNotificationsQuery: listQueryOptions,
      isLoading: t6,
      mutationValues: variables_0,
      unreadCount: t7,
      updateNotification,
      updatingNotification
    };
    $[16] = listQuery;
    $[17] = listQueryOptions;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = updateNotification;
    $[22] = updatingNotification;
    $[23] = variables_0;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}